import React from 'react';

const AlimentsHeader = () => {
  return (
    <h1>Aliments</h1>
  );
};

export default AlimentsHeader;
